module.exports = __webpack_public_path__ + "static/media/share.0f2e0896.svg";